import { defineStore } from 'pinia'
import { computed } from 'vue'
import { useBorrowerStore } from '~/store/borrower'
import { useTenantStore } from '~/store/tenant'

export const useErcOwnershipInfoStore = defineStore('ercOwnershipInfo',() => {
  const borrowerStore = useBorrowerStore()
  const tenantStore = useTenantStore()

/*
  ███████ ████████  █████  ████████ ███████
  ██         ██    ██   ██    ██    ██
  ███████    ██    ███████    ██    █████
       ██    ██    ██   ██    ██    ██
  ███████    ██    ██   ██    ██    ███████
  STATE
*/


/*
   ██████  ███████ ████████ ████████ ███████ ██████  ███████
  ██       ██         ██       ██    ██      ██   ██ ██
  ██   ███ █████      ██       ██    █████   ██████  ███████
  ██    ██ ██         ██       ██    ██      ██   ██      ██
   ██████  ███████    ██       ██    ███████ ██   ██ ███████
  GETTERS
*/

  const showAdditionalBusinesses = computed(() => {
      if (!borrowerStore.borrowerValues) {
        return
      }
      const ownsOtherBusinesses = borrowerStore.borrowerValues.contactsOwnOtherBusinesses
      const ownsOtherBusinessesValue = ownsOtherBusinesses && ownsOtherBusinesses.value
      if (ownsOtherBusinessesValue == "1" && !tenantStore.isTenant) {
          return true
      } else {
          return false
      }
  })

  const showRelatedOwners = computed(() => {
      if (!borrowerStore.borrowerValues) {
        return
      }
      const hasRelatedOwners = borrowerStore.borrowerValues.hasRelatedOwners
      const hasRelatedOwnersValue = hasRelatedOwners && hasRelatedOwners.value
      if (hasRelatedOwnersValue == "1" && !tenantStore.isTenant) {
          return true
      } else {
          return false
      }
  })

  const spouseOwnedBusinessesQuestionValue = computed(() => {
    const borrowerStore = useBorrowerStore()
      if (!borrowerStore.borrowerValues) {
        return
      }
      const spouseOwnsOtherBusinesses = borrowerStore.borrowerValues.spouseOwnsOtherBusinesses
      const spouseOwnsOtherBusinessesValue = spouseOwnsOtherBusinesses && spouseOwnsOtherBusinesses.value
      if (spouseOwnsOtherBusinessesValue == "1" && !tenantStore.isTenant) {
          return true
      } else {
          return false
      }
  })

  const showSecondSpouseOwnedBusinessesQuestion = computed(() => {
      if (!borrowerStore.borrowerValues) {
        return
      }
      const spouseOwnsOtherBusinesses2 = borrowerStore.borrowerValues.spouseOwnsOtherBusinesses2
      const spouseOwnsOtherBusinesses2Value = spouseOwnsOtherBusinesses2 && spouseOwnsOtherBusinesses2.value
      if (spouseOwnsOtherBusinesses2Value == "1" && !tenantStore.isTenant) {
          return true
      } else {
          return false
      }
  })

  const showSpouseOwnedBusinesses = computed(() => {
    if(spouseOwnedBusinessesQuestionValue.value && showSecondSpouseOwnedBusinessesQuestion.value){
      return true
    } else {
        return false
    }
  })

  const showOwnerRelatedEmployees = computed(() => {
      if (!borrowerStore.borrowerValues) {
        return
      }
      const hasOwnerRelatedEmployees = borrowerStore.borrowerValues.hasRelatedW2Employees
      const hasOwnerRelatedEmployeesValue = hasOwnerRelatedEmployees && hasOwnerRelatedEmployees.value
      if (hasOwnerRelatedEmployeesValue == "1" && !tenantStore.isTenant) {
          return true
      } else {
          return false
      }
  })

/*
   █████   ██████ ████████ ██  ██████  ███    ██ ███████
  ██   ██ ██         ██    ██ ██    ██ ████   ██ ██
  ███████ ██         ██    ██ ██    ██ ██ ██  ██ ███████
  ██   ██ ██         ██    ██ ██    ██ ██  ██ ██      ██
  ██   ██  ██████    ██    ██  ██████  ██   ████ ███████
  ACTIONS
  ! - - Actions calling other actions in the same store must use `this.actionName(...)`
  ! - - If we do not use `this.actionName` it will not be properly mockable in tests.
  ! - - Computeds and refs will work fine, and should be called directly though.
*/

  return {
    showAdditionalBusinesses,
    showRelatedOwners,
    spouseOwnedBusinessesQuestionValue,
    showSecondSpouseOwnedBusinessesQuestion,
    showSpouseOwnedBusinesses,
    showOwnerRelatedEmployees
  }
})
